import { useLayout } from "../../contexts/Layout";
import { useRoot } from "../../contexts/Root";
import { ClipButton } from "./ClipButton";
import { FullscreenButton } from "./FullscreenButton";
import { SettingsButton } from "./SettingsButton";
import styles from "./styles.module.css";

export const Actions = () => {
  const { setClippingEnabled } = useRoot();
  const { isMobile } = useLayout();

  return (
    <div className={styles.container}>
      {setClippingEnabled !== undefined && !isMobile && <ClipButton />}
      <SettingsButton />
      <FullscreenButton />
    </div>
  );
};
